// extracted by mini-css-extract-plugin
module.exports = {"container":"premium-PlanOptionUpgrade__container--1qm-8","badge":"premium-PlanOptionUpgrade__badge--3AIye"};